export default "__VITE_ASSET__54b3de35__"